import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { DialogShow_2 } from "../../../components/DialogService/DialogService";
// import FooterButton, { FooterButtonCenter } from '../../../components/FooterButton/FooterButton';
import { NullInt } from "../../../utilities/NullUtil";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
//PAGE
import P410List from "./P410List";
import P410Search2 from "./P410Search2";
import P410List2 from "./P410List2";
import P410Search3 from "./P410Search3";
import P410List3 from "./P410List3";
import P410Dialog from "./P401Dialog";

//CSS
import "../../../components/DataTable/DataTable.css";

//SERVICE
import { P401CreateDataLev1, P410GetDataList, P410GetDataListLev1, P410GetDataListLev2, P410GetDataListLev3, P401CreateDataLev3, P401CreateDataLev2 } from "../../../service/400/P410Service";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { NullString } from "../../../utilities/NullUtil";
import { formatDateAPI } from "../../../utilities/DateUtil";
import { Button } from "primereact/button";

export default function P410() {
    const history = useHistory();
    const toast = useRef(null);
    const [errData, setErrData] = useState(null);

    const [dialog, setDialog] = useState({ dialog: false, action: "" });
    const [loading, setLoading] = useState(false);
    const [action, setAction] = useState({ action: "บันทึก", tab: 1 });
    const [submitted, setSubmitted] = useState(false);

    const [showDialog, setShowDialog] = useState(false);
    const [textShow, setTextShow] = useState("");

    // SEARCH
    const [searchData] = useState({
        userId: dataUserSession() ? dataUserSession().userId : "",
    });
    const [searchLev1, setSearchLev1] = useState({
        versionNo: 0,
        userId: dataUserSession() ? dataUserSession().userId : "",
    });
    const [searchLev2, setSearchLev2] = useState({
        versionNo: 0,
        criteriaNo: 0,
        userId: dataUserSession() ? dataUserSession().userId : "",
        topicNo: 0,
    });

    const [searchLev3, setSearchLev3] = useState({
        criteriaNo: 0,
        itemNo: 0,
        userId: dataUserSession() ? dataUserSession().userId : "",
        versionNo: 0,
        active: false,
    });

    const [dataTable, setDataTable] = useState([]);
    const [dataTableA, setDataTableA] = useState([]);
    const [dataTableB, setDataTableB] = useState([]);

    const [dataInfoA, setDataInfoA] = useState({
        beginDate: new Date(),
        endDate: new Date(),
    });
    const [dataInfoB, setDataInfoB] = useState();

    useEffect(() => {
        if (!dataUserSession()) {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        console.log('action ',action);
    }, [action]);

    useEffect(() => {
        onP410GetDataList();
    }, [searchData]);

    useEffect(() => {
        onP410GetDataListLev1();
    }, [searchLev1]);

    useEffect(() => {
        onP410GetDataListLev2();
    }, [searchLev2]);

    useEffect(() => {
        onP410GetDataListLev3();
    }, [searchLev3]);

    const onP410GetDataList = () => {
        setLoading(true);
        P410GetDataList(searchData).then(
            (res) => {
                setLoading(false);
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onP410GetDataListLev1 = () => {
        setLoading(true);
        P410GetDataListLev1(searchLev1).then(
            (res) => {
                setLoading(false);
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });

                    if (temp.length > 0) {
                        setDataInfoA(temp[0]);

                        if (temp[0].topicNo && !(NullInt(temp[0].topicNo) === 0)) {
                            setDataTableA(temp);
                        } else {
                            setDataTableA([]);
                        }
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onP410GetDataListLev2 = () => {
        setLoading(true);

        const req = {
            criteriaNo: searchLev2.topicNo,
            userId: searchLev2.userId,
            versionNo: searchLev2.versionNo,
        };
        P410GetDataListLev2(req).then(
            (res) => {
                setLoading(false);
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });

                    if (temp.length > 0) {
                        setDataInfoB(temp[0]);

                        if (temp[0].itemNo) {
                            setDataTableB(temp);
                        } else {
                            setDataTableB([]);
                        }
                    }



                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onP410GetDataListLev3 = () => {
        setLoading(true);
        const req = { criteriaNo: searchLev2.topicNo, itemNo: searchLev3.itemNo, userId: dataUserSession() ? dataUserSession().userId : "", versionNo: searchLev3.versionNo };
        P410GetDataListLev3(req).then(
            (res) => {
                setLoading(false);
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    if (temp.length > 0) {
                        setDialog({ dialog: true, action: "EDIT", data: temp[0] });
                    } else if (searchLev3.active === true) {
                        setDialog({ dialog: true, action: "EDIT", data: searchLev3 });
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const validation = (object, lev) => {
        if (lev && lev === "lev1") {
            if (NullString(object.beginDate) === "" || NullString(object.endDate) === "") {
                setSubmitted(true);
                return false;
            } else {
                setSubmitted(false);
                return true;
            }
        }
        if (lev && lev === "lev2") {
            if (NullString(object.criteriaWeight) === "" || NullString(object.criteriaDesc) === "") {
                setSubmitted(true);
                return false;
            } else {
                setSubmitted(false);
                return true;
            }
        }

        if (lev && lev === "lev3") {
            if (NullString(object.itemType) === "" || NullString(object.itemDesc) === "" || NullString(object.itemWeight) === "") {
                setSubmitted(true);
                return false;
            } else {
                setSubmitted(false);
                return true;
            }
        } else {
            setSubmitted(true);
            return false;
        }
    };
    const submitFormLev1 = (submitForm) => {
        if (validation(submitForm, "lev1")) {
            setLoading(true);

            submitForm = {
                beginDate: submitForm.beginDate !== "" ? formatDateAPI(submitForm.beginDate, false) : "",
                endDate: submitForm.endDate !== "" ? formatDateAPI(submitForm.endDate, false) : "",
                userId: searchData.userId,
                remark: submitForm.remark,
                versionNo: submitForm.versionNo,
            };
            P401CreateDataLev1(submitForm).then(
                (res) => {
                    setLoading(false);
                    if (res.status === 200) {
                        if (res.data[0].statusText === "") {
                            if (res.data[0].statusCode === "C") {
                                setTextShow(`บันทึกสมบูรณ์ `);
                                setAction({
                                    ...action,
                                    action: "แก้ไข",
                                });
                            } else if (res.data[0].statusCode === "E") {
                                setTextShow(`มีข้อผิดพลาด`);
                            }
                        } else {
                            setTextShow(`${res.data[0].statusText}`);
                            setAction({
                                ...action,
                                tab: 1,
                            });
                            onP410GetDataList();
                        }
                        setShowDialog(true);
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }

                    onP410GetDataListLev1();
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const submitFormLev2 = (data) => {
        if (validation(data, "lev2")) {
            const req = {
                criteriaDesc: data.criteriaDesc,
                criteriaNo: data.criteriaNo === "" ? 0 : data.criteriaNo,
                criteriaWeight: data.criteriaWeight === "" ? 0 : data.criteriaWeight,
                userId: searchData.userId,
                versionNo: searchLev2.versionNo,
            };
            // console.log("🚀 ~ file: P410.js ~ line 329 ~ submitFormLev2 ~ req", req)
            P401CreateDataLev2(req).then(
                (res) => {
                    setLoading(false);
                    if (res.status === 200) {
                        if (res.data[0].statusText === "") {
                            if (res.data[0].statusCode === "C") {
                                setTextShow(`บันทึกสมบูรณ์ `);
                                setAction({
                                    ...action,
                                    action: "แก้ไข",
                                });
                            } else if (res.data[0].statusCode === "E") {
                                setTextShow(`มีข้อผิดพลาด`);
                            }
                        } else {
                            setTextShow(`${res.data[0].statusText}`);
                            setAction({
                                ...action,
                                tab: 2,
                            });
                            onP410GetDataListLev1();
                        }
                        setShowDialog(true);
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }

                    onP410GetDataListLev1();
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const submitFormLev3 = (data) => {
        if (validation(data, "lev3")) {
            const req = {
                criteriaNo: searchLev2.topicNo,
                itemDesc: data.itemDesc,
                itemNo: data.itemNo,
                itemType: data.itemType,
                itemWeight: NullInt(data.itemWeight),
                userId: searchData.userId,
                versionNo: searchLev2.versionNo,
            };
            console.log(req);
            P401CreateDataLev3(req).then(
                (res) => {
                    setLoading(false);
                    if (res.status === 200) {
                        if (res.data[0].statusText === "") {
                            if (res.data[0].statusCode === "C") {
                                setTextShow(`บันทึกสมบูรณ์ `);
                                setAction({
                                    ...action,
                                    action: "แก้ไข",
                                });
                            } else if (res.data[0].statusCode === "E") {
                                setTextShow(`มีข้อผิดพลาด`);
                            }
                        } else {
                            setDialog({ dialog: false, action: "" });
                            setTextShow(`${res.data[0].statusText}`);
                            setAction({
                                ...action,
                                tab: 3,
                            });
                            onP410GetDataListLev2();
                        }
                        setShowDialog(true);
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }

                    onP410GetDataListLev1();
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const onChangeAction = (tab = 1, act = "บันทึก") => {
        setAction({
            action: act,
            tab: tab,
        });
    };

    const handlerDiaLv4 = (dataRow) => {
        if (dataRow.data != null) {
            setSearchLev3({ ...searchLev3, ...dataRow.data, active: true });
        } else {
            setDialog({ dialog: true, action: "NEW", data: { itemNo: 0 } });
        }
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <P410Search searchWord={searchWord} setSearchWord={setSearchWord} submitForm={submitForm}  /> */}
                        {/* {renderBody()} */}

                        {action && action.tab === 2 ? (
                            <>
                                {/* <h2 className="p-m-0">เพิ่ม/แก้ไข หัวข้อพิจารณา 2</h2>
                                <hr /> */}
                                <P410Search2 action={action} submitted={submitted} submitForm={submitFormLev1} onChangeAction={onChangeAction} dataInfoA={dataInfoA} />
                                <P410List2 action={action} dataTable={dataTableA} onChangeAction={onChangeAction} dataInfoA={dataInfoA} setSearchLev2={setSearchLev2} searchLev2={searchLev2} />
                            </>
                        ) : action && action.tab === 3 ? (
                            <>
                                {/* <h2 className="p-m-0">รายละเอียดหัวข้อพิจารณา 3</h2>
                                <hr /> */}
                                <P410Search3 action={action} submitted={submitted} submitForm={submitFormLev2} onChangeAction={onChangeAction} dataInfoB={dataInfoB} />
                                <P410List3 action={action} dataTable={dataTableB} onChangeAction={onChangeAction}  sethandlerDiaLv4={handlerDiaLv4} />
                            </>
                        ) : (
                            <>
                                {/* <h2 className="p-m-0">กำหนดหัวข้อหลักเกณฑ์การประเมิน 1</h2>
                                <hr /> */}
                                <div className="p-grid  p-fluid">
                                <div className="p-field p-col-12 p-md-6">
                                    <Button
                                        className="p-button-secondary p-button btn-long-top-responsive"
                                        icon="pi pi-arrow-left"
                                        label="กลับหน้าจอหลัก"
                                        // style={{ display: 'flex',marginBottom : '10px' }}
                                        style={{ width: 170, marginLeft: "5px" }}
                                        onClick={() => {
                                            history.push("/400");
                                        }}
                                    />
                                </div>
                            </div>
                                <P410List dataTable={dataTable} onChangeAction={onChangeAction} setSearchLev1={setSearchLev1} searchLev1={searchLev1} />
                            </>
                        )}

                        {dialog.dialog === true ? (
                            <>
                                <P410Dialog dialog={dialog} setDialog={setDialog} setsubmitForm={(e) => submitFormLev3(e)} dataTable={dataTable} submitted={submitted} />
                            </>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>

            <DialogShow_2 visible={showDialog} header="แจ้งเตือน" modal onHide={() => setShowDialog(false)} className="p-fluid" textContent={textShow} btnCancle={() => setShowDialog(false)} />
        </>
    );
}
